var events = (function () {
    function addRemove(op, events, cb) {
        if (cb)
            events.split('.').forEach(name => {
                var ev = name.split('.')[0]
                cb = cb || this._eventsNS[name]

                this[op + 'EventListener'].call(this, ev, cb)

                if (op == 'add')
                    this._eventsNS[name] = cb
                else
                    delete this._eventsNS[name]
            })
    }

    function on(events, cb) {
        this._eventsNS = this._eventsNS || {} // save the _eventsNS on the DOM element itself
        addRemove.call(this, 'add', events, cb)
        return this
    }

    function off(events, cb) {
        addRemove.call(this, 'remove', events, cb)
        return this
    }

    // need to work on this method, it is the hardest.
    // currently I do not know how to dispatch real events (with namespace) like UIEvent, KeyboardEvent, PointerEvent and so no
    function trigger(eventName, data) {
        var e;
        // Don't do events on text and comment nodes
        if (!eventName) return
        let realEventName = eventName.split('.')[0];
        try {
            if (data) e = new CustomEvent(realEventName, {detail: data})
            else e = new CustomEvent(realEventName)
        }
        catch (err) { console.warn(err) }
        this.dispatchEvent(e)
    }

    return { on, off, trigger }
})()

// Extend the DOM with these above custom methods
window.$on = document.$on = Element.prototype.$on = events.on;
window.$off = document.$off = Element.prototype.$off = events.off;
window.$trigger = document.$trigger = Element.prototype.$trigger = events.trigger;


window.classAdd = function(els, cl) {
    if (!els) return;
    if (els.classList) {
        els.classList.add(cl)
        return;
    }
    if (els.length) {
        els.forEach(function (elm) {
            elm.classList.add(cl)
        })
    }
}


window.classRemove = function(els, cl) {
    if (!els) return;
    if (els.classList) {
        els.classList.remove(cl)
        return;
    }
    if (els.length) {
        els.forEach(function (elm) {
            elm.classList.remove(cl)
        })
    }
}


window.eventAdd = function(els, ev, cb) {
    if (!els) return;
    if (els.$on) {
        els.$on(ev, cb);
        return;
    }
    if (els.length) {
        els.forEach(function (elm) {
            elm.$on(ev, cb);
        })
    }
}


window.eventRemove = function(els, ev) {
    if (!els) return;
    if (els.$off) {
        els.$off(ev);
        return;
    }
    if (els.length) {
        els.forEach(function (elm) {
            elm.$off(ev);
        })
    }
}

window.toggleChildsTabindex = function (el, state) {
    let childs = el.querySelectorAll('a, button, input, select, textarea, [tabindex]');
    childs.forEach(child => {
        child.setAttribute('tabindex', state);
    })
}
